import { useParams } from 'react-router-dom';

import Page from '@/components/layout/Page';
import HeaderWithBack from '@/components/common/HeaderWithBack';
import PageLoading from '@/components/layout/PageLoading';
import Error from '@/components/common/Error';
import { Card, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import CartItem from '@/app/cartItem/CartItem';
import CartSummary from '@/app/cart/CartSummary';
import Tender from '@/app/order/components/Tender';

import { useOrder } from '@/data/order';

const View = () => {
  const params = useParams();
  const order = useOrder(params.id);

  return (
    <Card>
      <CardContent className="p-2">
        <h2 className="text-2xl leading-none font-semibold mb-3">
          Order #{order.data.orderNum}
        </h2>
        <Separator className="my-4" />
        <div className="space-y-4 py-2">
          {order.data.items.map((orderItem) => (
            <CartItem cartItem={orderItem} key={orderItem.id} isOrder />
          ))}
        </div>
        <CartSummary cart={order.data} />
        <div className="mt-4">
          <h3 className="text-md font-semibold mb-2">Payment</h3>
          {order.data.tenders.map((tender) => (
            <Tender tender={tender} key={tender.id} />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

const OrderPage = () => {
  const params = useParams();
  const backLink = '/booking';

  const order = useOrder(params.id);

  if (order.isLoading && !order.data) {
    return (
      <Page>
        <HeaderWithBack to={backLink} title="Bookings" />
        <div className="flex justify-center items-center h-[calc(100vh-180px)]">
          <PageLoading />
        </div>
      </Page>
    );
  }

  if (order.error) {
    return (
      <Page>
        <HeaderWithBack to={backLink} title="Bookings" />
        <div className="flex justify-center items-center h-[calc(100vh-180px)]">
          <Error error="There was an error loading the order" />
        </div>
      </Page>
    );
  }

  return (
    <Page>
      <HeaderWithBack to={backLink} title="Bookings" />
      <View />
    </Page>
  );
};

export default OrderPage;
